import { render } from "./InviteToCollaborateOnPlatform.vue.js?vue&type=template&id=d4004022!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./InviteToCollaborateOnPlatform.vue?vue&type=template&id=d4004022"
import script from "./InviteToCollaborateOnPlatform.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./InviteToCollaborateOnPlatform.vue?vue&type=script&lang=js"
export * from "./InviteToCollaborateOnPlatform.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./InviteToCollaborateOnPlatform.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/publication/InviteToCollaborateOnPlatform.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d4004022"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d4004022', __exports__)) {
    api.reload('d4004022', __exports__)
  }
  
  module.hot.accept("./InviteToCollaborateOnPlatform.vue.js?vue&type=template&id=d4004022!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./InviteToCollaborateOnPlatform.vue?vue&type=template&id=d4004022", () => {
    api.rerender('d4004022', render)
  })

}


export default __exports__